<template lang="pug">
ul.links
  li(
    v-if="menuEN.MenuList && menuEN.MenuList.length > 0",
    v-for="(link, index) in menuEN.MenuList",
    :key="index",
    :class="{ selected: checkSelect(link.PageJson) }"
  )
    router-link(
      tag="a",
      :to="{ name: 'English', params: { page: link.PageJson } }"
    ) {{ link.MenuTitle }}
</template>
<script>
import { getMenuEN } from "@/json/menu";

export default {
  name: "Links",
  data() {
    return {
      menuEN: {},
    };
  },
  created() {
    this.getMenuEN();
  },
  methods: {
    getMenuEN() {
      getMenuEN().then((response) => {
        this.menuEN = response.data;
        this.$router.push({
          name: "English",
          params: {
            page: this.menuEN.MenuList[0].PageJson,
          },
        });
      });
    },
    checkSelect(NAME) {
      if (NAME == this.$route.params.page) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/lang/link";
</style>
